<template>
	<div id="home">
        <section id="intro">
			<img class="profil__photo" src="../assets/moi.jpg"/>
			<div class="intro__content">
				<h1>Alain LAM</h1>
				<p>Le plus fidèle ami de l'homme est Google, désolé Rouky ...</p>
			</div>
		</section>
        <section id="about-me">
			<div class="about-me__container">
				<h2>Résumé et aspirations futures</h2>
				<p>
					Diplomé en génie des technologies de l'information, je suis passionné par les nouvelles technologies.
					Plus particulièrement, le design UI et UX, l'apprentissage machine (AI) ainsi que l'informatique décisionnelle (BI).
					Toujours prêt à relever de nouveaux défis et apprendre de nouveaux langages.
					<br><br>
					<strong>Après m'être formé en Vue.js et CSS, j'ai pour but de maitriser le développement frontend
						en UI/UX en utilisant le framework Vue.js.</strong>
				</p>
			</div>
		</section>
		<div class="separator separator--grey">
			<div class="seprator__content">
				<h2>Expérience de travail</h2>
				<p>
					Liste des expériences de travail pertinentes incluant les emplois permanents, temps partiels et stages.
				</p>
			</div>
		</div>
        <section id="job__cgi" :class="{paint: jobList.cgi}" class="job__section cgi__color">
			<div class="section-triangle section-triangle--grey"></div>
            <div v-on:click="clickJob('cgi')" v-onscroll:inview.effect__fade.up class="job__container job__container--reverse">
				<div class="job__image"><img src="../assets/cgi.svg" alt="cgi_logo"></div>
				<div class="job__info">
					<h2 class="job__title">Analyste développeur Mainframe</h2>
					<p>Depuis Juillet 2019</p>
					<div class="job__description">
						<p class="job__project">Épuisement du plan de numérotation</p>
						<ul>
							<li>Analyse approfondie des impacts systèmes</li>
							<li>Rédaction de rapports d'analyse (HLE)</li>
							<li>Développement de correctifs</li>
						</ul>
					</div>
				</div>
			</div>
        </section>
        <section id="job__bell" :class="{paint: jobList.bell}" class="job__section bell__color">
			<div v-on:click="clickJob('cgi')" class="section-triangle clickable" :class="{'section-triangle--cgi': jobList.cgi, 'hide': jobList.cgi}"><p><strong>Open me</strong></p></div>
			<div v-on:click="clickJob('bell')" v-onscroll:inview.effect__fade.up class="job__container">
				<div class="job__image"><img src="../assets/bell.svg" alt="bell_logo"></div>
				<div class="job__info">
					<h2 class="job__title">Spécialiste approvisionnement réseau (Stage)</h2>
					<p>Mai 2018 – Août 2018</p>
					<div class="job__description">
						<p class="job__project">Automatisation de la récuperation et de l'affichage des données</p>
						<ul>
							<li>Évaluation des besoins en ressources et en temps des projets</li>
							<li>Développement d’applications intranet SQL/Microstrategy</li>
							<li>Support des gestionnaires de réseau</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
		<section id="job__novipro" :class="{paint: jobList.novipro}" class="job__section novipro__color">
			<div v-on:click="clickJob('bell')" class="section-triangle clickable section-triangle--grey" :class="{'section-triangle--bell': jobList.bell}"></div>
            <div v-on:click="clickJob('novipro')" v-onscroll:inview.effect__fade.up class="job__container job__container--reverse">
				<div class="job__image"><img src="../assets/novipro.png" alt="Novipro Logo"></div>
				<div class="job__info">
					<h2 class="job__title">Novipro<br>Développeur SQL</h2>
					<p>Déc. 2017 – Fév. 2018</p>
					<div class="job__description">
						<p class="job__project">Automatisation du déploiement de fonctionnalités entre différents serveurs de base de données</p>
						<ul>
							<li>Analyse du processus de déploiement entre les serveurs</li>
							<li>Écriture de script MSSQL</li>
							<li>Test des scripts</li>
						</ul>
						<br/>
						<p class="job__project">Déploiement de SecureLink dans les serveurs du client</p>
						<ul>
							<li>Informer le client d'un nouveau processus de développement</li>
							<li>Supporter le client lors du déploiement et de l'utilisation de SecureLink</li>
						</ul>
					</div>
				</div>
			</div>
        </section>
		<section id="job__imds" :class="{paint: jobList.imds}" class="job__section imds__color">
			<div v-on:click="clickJob('novipro')" class="section-triangle clickable" :class="{'section-triangle--novipro': jobList.novipro}"></div>
            <div v-on:click="clickJob('imds')" v-onscroll:inview.effect__fade.up class="job__container">
				<div class="job__image"><img src="../assets/imds.png" alt="IMDS Logo"></div>
				<div class="job__info">
					<h2 class="job__title">IMDS Software<br>Analyste développeur</h2>
					<p>Mai 2015 – Août 2016</p>
					<div class="job__description">
						<p class="job__project">Site internet de numérisation de documents en JAVA</p>
						<ul>
							<li>Conception de l’architecture logicielle</li>
							<li>Implémentation d’architecture de traitements parallèles</li>
							<li>Conception d’interface utilisateur dynamique</li>
							<li>Écriture de plugin jQuery</li>
							<li>Implémentation d’interface logicielle de pilotage d’appareils de numérisations</li>
							<li>Écriture de test unitaire</li>
							<li>Rédaction de document d’analyse et d’utilisation</li>
							<li>Développement sous la méthode AGILE</li>
						</ul>
					</div>
				</div>
			</div>
        </section>
		<section id="job__pixel" :class="{paint: jobList.pixel}" class="job__section pixel__color">
			<div v-on:click="clickJob('imds')" class="section-triangle clickable section-triangle--grey" :class="{'section-triangle--imds': jobList.imds}"></div>
            <div v-on:click="clickJob('pixel')" v-onscroll:inview.effect__fade.up class="job__container job__container--reverse">
				<div class="job__image"><img src="../assets/pixel.png" alt="Pixel Logo"></div>
				<div class="job__info">
					<h2 class="job__title">Pixel Artifex<br>Développeur Web</h2>
					<p>Déc. 2017 – Fév. 2018</p>
					<div class="job__description">
						<p class="job__project">Site internet de réservation d’hôtel en PHP</p>
						<ul>
							<li>Conception d’interface utilisateur</li>
							<li>Communication avec des web services</li>
							<li>Traitement des réponses XML</li>
						</ul>
					</div>
				</div>
			</div>
        </section>
		<div class="separator separator--grey">
			<div class="seprator__content">
				<h2>Projets</h2>
				<p>
					Projets effectués sur le temps libre.
				</p>
			</div>
		</div>
		<section id="scroller">
			<div class="section-triangle section-triangle--grey"></div>
			<div style="position: relative; width: 100%;">
				<!-- <div class="scroller__background"></div> -->
				<div class="scroller__container">
					<div class="scroller__project__container">
						<img src="../assets/technology/vue.svg" class="vue" alt="Logo Vue.js">
						<div class="scroller__project__content">
							<h2>Vue.js</h2>
							<div class="scroller__project__description">
								Le domaine web ayant toujours été un domaine qui m'intérressait du fait de la créativité et la résolution
								de problèmes par l'intégration, Vue.js a été un choix logique. Combinant les avantages de framework tel que Angular
								et React, Vue.js est un outil formidable.
							</div>
							<!-- <div class="scroller__project__list">
								<strong>Projet</strong>:
								<ul>
									<li>Portefolio</li>
								</ul>
							</div> -->
						</div>
					</div>
					<hr/>
					<div class="scroller__project__container scroller__project__container--reverse">
						<img src="../assets/technology/ethereum.svg" alt="Logo Vue.js">
						<div class="scroller__project__content">
							<h2>Cryptomonnaie</h2>
							<div class="scroller__project__description">
								La cryptomonnaie est un domaine fascinant qui a eu un pic d'intérêt il y a environ {{ estimateCryptoPeriod }} ans.
								Je m'y suis alors intensément intéressé au point d'y investir ...
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section id="technology">
			<h2>Outils et technologies</h2>
			<div class="technology__container">
				<div v-for="techno in technologyList" :key="techno" class="technology__item">
					<img class="technology__logo" :src="getTechnologyUrl(techno)"/>
				</div>
			</div>
		</section>
		<section id="pdf">
			<h2>En version PDF</h2>
			<div class="pdf__container">
				<a class="pdf__link" href="./CV-Alain-LAM-genie-TI.pdf" target="_blank"><img src="../assets/pdf.svg" alt="Lien CV PDF"></a>
			</div>
		</section>
	</div>
</template>

<script>

export default {
	data () {
		return {
			jobList: {
				cgi: false,
				bell: false,
				novipro: false,
				imds: false,
				pixel: false
			},
			technologyList: {
				android: 'android.svg',
				bootstrap: 'bootstrap.svg',
				css: 'css3.svg',
				discord: 'discord.svg',
				firefox: 'firefox.svg',
				git: 'git.svg',
				github: 'github.svg',
				google: 'google.svg',
				gradle: 'gradle.svg',
				hibernate: 'hibernate.svg',
				html5: 'html5.svg',
				intellij: 'intellij-idea.svg',
				java: 'java.svg',
				jquery: 'jquery.svg',
				js: 'js.svg',
				kotlin: 'kotlin.svg',
				mysql: 'mysql.svg',
				postgresql: 'postgresql.svg',
				spring: 'spring.svg',
				tomcat: 'tomcat.svg',
				visual: 'visual-studio-code.svg',
				vue: 'vue.svg'
			}
		}
	},
	computed: {
		estimateCryptoPeriod () {
			let cryptoStart = new Date('08/01/2017')
			let now = Date.now()
			return Math.floor((now - cryptoStart) / (1000 * 3600 * 24 * 7 * 4 * 12))
		}
	},
	methods: {
		clickJob (job) {
			this.jobList[job] = !this.jobList[job]
		},
		getTechnologyUrl (logoName) {
			return require('../assets/technology/' + logoName)
		}
	}
}
</script>

<style scoped>
	#home {
        min-height: calc(400vh - 10vh);
    }

    #intro {
		position: relative;
        height: 100vh;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
        background-color: #f3f3f3;
		background-image: url('../assets/mac3.jpg');
		background-size: auto 100%;
		background-position: 60% 100%;
		box-shadow: inset 0 0 0 100vmax rgba(168, 168, 168, 0.842);
    }

	.intro__content {
		display: flex;
		justify-content: center;
		flex-direction: column;
		text-align: center;
	}

	#intro__content h1 {
		letter-spacing: 5px;
		text-transform: uppercase;
		text-align: center;
		margin: 1rem;
	}

	.profil__photo {
		border-radius: 50%;
		border: 4px solid #272727;
		width: 15rem;
	}

    #about-me {
        display: flex;
		flex-direction: column;
        justify-content: center;
        align-items: center;
		background-color: #ffffff;
    }

	.about-me__container {
		padding: 2rem 2rem;
		text-align: center;
	}

	.about-me__container p {
		text-align: justify;
	}

	.section-triangle p {
		transform: translate(-25px, -95px);
		text-align: center;
		width: 3rem;
	}

	.section-triangle.clickable {
		cursor: pointer;
	}

	.section-triangle.hide {
		color: rgba(0, 0, 0, 0);
		cursor: context-menu;
	}

	.section-triangle--cgi {
		border-top-color: #ca2f43;
	}

	.section-triangle--bell {
		border-top-color: #0066a4;
	}

	.section-triangle--novipro {
		border-top-color: #79a837;
	}

	.section-triangle--imds {
		border-top-color: #d66800;
	}

	.job__section {
		position: relative;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

    .job__container {
		width: 95%;
		display: flex;
		align-items: center;
		flex-direction: row;
		margin: 0;
		padding: 8rem 2rem 1rem 2rem;
		opacity: 1;
	}

	.job__container:hover .job__image img {
		transform: scale(1.1);
	}

	.job__container--reverse {
		flex-direction: row-reverse;
	}

	.job__container--reverse .job__title,
	.job__container--reverse .job__description {
		text-align: right;
	}

	.job__container--reverse .job__description ul {
		list-style-position: inside;
	}

	.job__image img {
		margin: 1.5rem;
		width: 12rem;
		transition: all 0.5s ease-out;
	}

    .job__image img:hover {
        cursor: pointer;
    }

	.job__info {
		display: flex;
		flex-direction: column;
	}

	.job__container--reverse .job__info {
		align-items: flex-end;
	}

	.job__info p {
		margin: 0.5rem 0;
	}

	.job__title {
		letter-spacing: 4px;
		text-transform: uppercase;
		font-size: 1.9rem;
		margin: 0 0 0.5rem 0;
		font-weight: bold;
	}

	.job__description {
		letter-spacing: 1.5px;
		font-size: 0;
		margin: 0;
		opacity: 0;
		padding: 0;
		transition: opacity .25s,
					font-size .5s .25s,
					margin .5s .25s,
					padding .5s .25s;
	}

	.paint .job__description {
		font-size: inherit;
		margin: 0;
		opacity: 1;
		transition: font-size .25s,
					margin .25s,
					padding .25s,
					opacity .5s .25s;
	}

	.job__project {
		text-decoration: underline;
	}

	#job__cgi {
		background-color: #ffffff;
	}

	.cgi__color {
		background-image: linear-gradient(to left, transparent 50%, #ca2f43 50%);
		background-size: 200% 100%;
		background-position: -100% 0;
		transition: all 0.5s ease-out;
	}

	#job__bell {
		background-color: #f3f3f3;
	}

	.bell__color {
		background-image: linear-gradient(to right, #0066a4 50%, transparent 50%);
		background-size: 200% 100%;
		background-position: 100% 0;
		transition: all 0.5s ease-out;
	}

	#job__bell.paint .job__image img {
		filter: brightness(0) invert(1);
	}

	#job__novipro {
		background-color: #ffffff;
	}

	.novipro__color {
		background-image: linear-gradient(to left, transparent 50%, #79a837 50%);
		background-size: 200% 100%;
		background-position: -100% 0;
		transition: all 0.5s ease-out;
	}

	#job__imds {
		background-color: #f3f3f3;
	}

	.imds__color {
		background-image: linear-gradient(to right, #d66800 50%, transparent 50%);
		background-size: 200% 100%;
		background-position: 100% 0;
		transition: all 0.5s ease-out;
	}

	#job__imds.paint .job__image img {
		filter: brightness(0) invert(1);
	}

	#job__pixel {
		background-color: #ffffff;
	}

	.pixel__color {
		background-image: linear-gradient(to right, #333333 50%, transparent 50%);
		background-size: 200% 100%;
		background-position: -100% 0;
		transition: all 0.5s ease-out;
	}

	.paint {
		background-position: 0 0;
	}

	.paint .job__container {
		color: white;
	}

	#scroller {
		position: relative;
		width: 100%;
		background-color: #f3f3f3;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.scroller__background {
		position: sticky;
		top: 0;
		left: 0;
		height: 100vh;
		width: 100%;
		background-color: #ffffff;
		background-color: #f3f3f3;
		background-image: url('../assets/random.jpg');
		box-shadow: inset 0 0 0 100vmax rgba(34, 34, 34, 0.8);
		background-repeat: no-repeat;
		background-position: center;
	}

	.scroller__container {
		position: relative;
		width: 100%;
		padding: 5rem 12rem;
		color: white;
		background-image: url('../assets/random.jpg');
		box-shadow: inset 0 0 0 100vmax rgba(34, 34, 34, 0.8);
		z-index: 2;
	}

	.scroller__container hr {
		margin: 3rem 0;
		color: #cfcfcfcb
	}

	.scroller__project__container {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.scroller__project__container--reverse {
		flex-direction: row-reverse;
	}

	.scroller__project__container img {
		width: 14rem;
		height: 14rem;
	}

	.scroller__project__container .vue {
		width: 10rem;
		height: 10rem;
	}

	.scroller__project__content {
		text-align: justify;
	}

	.scroller__project__container .scroller__project__content {
		margin-left: 2rem;
	}

	.scroller__project__container--reverse .scroller__project__content {
		margin-right: 2rem;
	}

	.scroller__project__list {
		margin: 1rem 0 0 0;
	}

	#technology {
		width: 100%;
		background-color: #f3f3f3;
		padding: 2rem;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.technology__container {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
	}

	.technology__item {
		padding: 1rem 1rem;
	}

	.technology__logo {
		width: 4rem;
		filter: grayscale(100%);
	}

	.technology__logo:hover {
		filter: none;
	}

	#pdf {
		width: 100%;
		background-color: #ffffff;
		padding: 2rem;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.pdf__container {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
	}

	.pdf__link img {
		width: 8rem;
		height: 8rem;
	}

	@media (min-width: 75rem) {
		.job__container {
			margin: 0;
			padding-top: 8rem;
		}

		.job__info {
			padding-left: 3rem;
			padding-right: 0rem;
		}

		.job__container--reverse .job__info {
			padding-left: 0rem;
			padding-right: 3rem;
		}
	}

	@media (max-width: 55rem) {
		.scroller__container {
			padding: 7rem 8rem 5rem 8rem;
		}

		.scroller__container hr {
			margin: 4rem 0;
		}

		.scroller__project__container {
			flex-direction: column;
		}

		.scroller__project__container img {
			width: 10rem;
			height: 10rem;
		}

		.scroller__project__container .vue {
			width: 8rem;
			height: 8rem;
		}

		.scroller__project__content {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin: 0;
		}

		.scroller__project__list {
			align-self: flex-start;
		}
	}

	@media (max-width: 40rem) {
		#intro {
			display: flex;
			justify-content: center;
			height: calc(100vh - 3rem);
		}

		.intro__content {
			padding: 1rem;
		}

		.profil__photo {
			position: absolute;
			bottom: -2.5rem;
			left: calc(50% - 5rem);
			width: 10rem;
		}

		#intro__content h1 {
			position: initial;
			padding-top: 9rem;
		}

		.job__container {
			flex-direction: column;
			flex: 1;
		}

		.job__image img {
			width: 10rem;
		}

		.job__title {
			font-size: 1.2rem;
			text-align: center !important;
		}

		.job__info p {
			margin: auto;
		}

		.job__description {
			text-align: left !important;
			padding: 1rem 1.5rem;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}

		.job__description p {
			text-align: center;
		}

		.job__container--reverse .job__description ul {
			list-style: initial;
		}

		.scroller__container {
			padding: 8rem 2rem 5rem 2rem;
		}

		.scroller__project__container img {
			width: 8rem;
			height: 8rem;
		}

		.scroller__project__container .vue {
			width: 7rem;
			height: 7rem;
		}

		.technology__logo {
			filter: none;
		}
	}
</style>
